export default __webpack_public_path__ + "static/media/material-mock.ef4de9a2.jpg";